import { render } from "./AllRightReserved.vue?vue&type=template&id=8642022a&scoped=true"
const script = {}

import "./AllRightReserved.vue?vue&type=style&index=0&id=8642022a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8642022a"]])

export default __exports__